<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo-section">
        <img alt="Logo" src="@/assets/images/WelcomePage/logo.png" class="logo" />
        <h2 class="title">PAR-Q问卷登录</h2>
      </div>

      <el-form ref="loginForm" :model="loginForm" :rules="rules" class="login-form">
        <el-form-item prop="disabilityNo">
          <el-input v-model="loginForm.disabilityNo" placeholder="请输入残疾证号" prefix-icon="el-icon-user" />
        </el-form-item>

        <el-form-item prop="name">
          <el-input v-model="loginForm.name" placeholder="请输入姓名" prefix-icon="el-icon-user-solid" />
        </el-form-item>

        <el-form-item prop="parPassword">
          <el-input v-model="loginForm.parPassword" :type="passwordVisible ? 'text' : 'password'" placeholder="请输入认证口令" prefix-icon="el-icon-lock">
            <i slot="suffix" class="el-icon-view password-toggle" :class="{ 'password-visible': passwordVisible }" @click="togglePasswordVisibility" />
          </el-input>
        </el-form-item>

        <div class="button-group">
          <el-button @click="resetForm" class="reset-btn">重置</el-button>
          <el-button type="primary" @click="submitForm" :loading="loading" class="submit-btn"> 开始问卷 </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { LoginCheckUser } from '@/api/parq/parq'

export default {
  name: 'HomeView',
  data() {
    return {
      institutionId: '',
      passwordVisible: false,
      loading: false,
      loginForm: {
        disabilityNo: '',
        name: '',
        parPassword: ''
      },
      rules: {
        disabilityNo: [{ required: true, message: '请输入残疾证号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        parPassword: [{ required: true, message: '请输入认证口令', trigger: 'blur' }]
      }
    }
  },
  created() {
    // 设置页面标题
    document.title = '问卷登录'
    // 获取URL查询参数
    const urlParams = new URLSearchParams(window.location.search)
    this.institutionId = urlParams.get('institutionId')
    if (!this.institutionId) {
      this.$message.warning('缺少必要参数institutionId')
    }
  },
  methods: {
    // 切换密码显示/隐藏状态
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible
    },

    // 重置表单
    resetForm() {
      this.$refs.loginForm.resetFields()
    },

    // 提交登录表单
    async submitForm() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          if (!this.institutionId) {
            this.$message.error('缺少必要参数institutionId')
            return
          }

          this.loading = true
          try {
            const requestData = {
              institutionId: this.institutionId,
              disabilityNo: this.loginForm.disabilityNo,
              name: this.loginForm.name,
              parPassword: this.loginForm.parPassword
            }

            const response = await LoginCheckUser(requestData)

            if (response.code === 200) {
              // 存储用户信息到Vuex
              this.$store.dispatch('global/setUserInfo', {
                name: this.loginForm.name,
                clientId: response.data,
                institutionId: this.institutionId
              })

              // 跳转到问卷页面，同时传递用户信息参数
              this.$router.push({
                path: '/parq',
                query: {
                  name: this.loginForm.name,
                  clientId: response.data,
                  institutionId: this.institutionId
                }
              })
            } else {
              this.$message.error(response.msg || '登录失败，请检查输入信息')
            }
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 50%, #90caf9 100%);
  padding: 20px;
  overflow: hidden;
}

.login-box {
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 32px rgba(33, 150, 243, 0.1);
  border: 1px solid rgba(33, 150, 243, 0.1);
  padding: 40px 30px;
}

.logo-section {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  width: 120px;
  height: auto;
  max-height: 80px;
  object-fit: contain;
  margin-bottom: 20px;
}

.title {
  color: #1976d2;
  margin: 0;
  font-size: 24px;
  font-weight: 500;
}

.login-form {
  margin-top: 30px;
}

.login-form .el-form-item {
  margin-bottom: 20px;
}

.password-toggle {
  cursor: pointer;
  color: #333;
  transition: color 0.3s;
  font-size: 16px;
  z-index: 10;
  position: relative;
  user-select: none;
  display: inline-block;
}

.password-toggle.password-visible {
  color: #2196f3;
}

.password-toggle:hover {
  opacity: 0.7;
}

.button-group {
  display: flex;
  gap: 15px;
  margin-top: 25px;
  justify-content: center;
}

.reset-btn {
  width: 120px;
  display: block;
  margin: 0;
}

.submit-btn {
  width: 150px;
  display: block;
  margin: 0 !important;
  margin-left: 0 !important;
}

/* 移动端适配 */
@media (max-width: 480px) {
  .login-container {
    padding: 10px;
  }

  .login-box {
    padding: 30px 20px;
  }

  .logo {
    width: 120px;
    height: auto;
    max-height: 60px;
    object-fit: contain;
  }

  .title {
    font-size: 20px;
  }

  .button-group {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }

  .reset-btn,
  .submit-btn {
    width: 100%;
    display: block;
    margin: 0 !important;
    margin-left: 0 !important;
  }

  .password-toggle {
    font-size: 18px !important;
    color: #333 !important;
    z-index: 999 !important;
    position: relative !important;
    display: inline-block !important;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer !important;
  }

  .password-toggle.password-visible {
    color: #2196f3 !important;
  }

  /* 确保Element UI输入框suffix在移动端正确显示 */
  .el-input__suffix {
    right: 15px !important;
  }

  .el-input__suffix-inner {
    display: flex !important;
    align-items: center !important;
  }
}
</style>
